<template>
  <div class="w-100 px-5 mb-5">
    <div style="border: 20px solid white;">
      <div style="height:600px" class="bg-akdemica d-flex justify-content-center align-items-center">
        <h1>VIDEO</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
